import TodoProperties from "./todo-properties"
import DatetimeUtils from "../../../gd/utils/datetime-utils"
import TodoList from "../todo-list";
import TaskProperties from "./task-properties";

export const TODO_ITEM = 'todo'
export const TASK_ITEM = 'task'

export enum TodoType {
    TODO = 'todo',
    TASK = 'task'
}

const debug = false
// const debug = "TodoListItem"

export default class TodoListItem {

    public todoList           : TodoList
    public uid                : ID

    public type               : TodoType
    public taskId             : ID | null
    public momentCreated      : Moment | null
    public createdByUserId    : ID | null

    public access             : {
        add : boolean,
        edit : boolean
    }

    // @ts-ignore
    public properties       : TaskProperties | TodoProperties

    constructor(todoList:TodoList, data:any) {
        this.todoList           = todoList
        this.uid                = _.get(data, 'uid', this.todoList.generateId())

        this.type               = _.get(data, 'type', TodoType.TODO)
        this.taskId             = _.get(data, 'taskId', null) // for TASK_ITEM only
        this.momentCreated      = DatetimeUtils.datetimeToMoment(_.get(data,'momentCreated',null))
        this.createdByUserId    = _.get(data,'createdByUserId',null)

        // init access
        this.access = {
            add : this.todoList.access.add,
            edit: this.todoList.access.edit || this.createdByUserId === gd.session.me.id
        };

        // this.normalize(data.properties);

        switch (this.type) {
            case TodoType.TASK:
                this.properties = new TaskProperties(data.properties);
                break
            case TodoType.TODO:
                this.properties = new TodoProperties(data.properties); break
            default:
                break
        }
    }

    // should be used to create new items
    static create(todoList:TodoList, data:any) {

        data.momentCreated      = _.get(data,'momentCreated',moment())
        data.createdByUserId    = _.get(data,'createdByUserId',gd.session.me.id)

        return new TodoListItem(todoList, data)
    }

    get name() {return this.properties.getName()}
    get isCompleted() {return this.properties.isCompleted()}

    get isTaskMessage():boolean {

        // @ts-ignore
        const {messageId} = this.properties
        if (messageId) {
            const message = this.todoList.manager.app.messagesManager.getById(messageId)
            if (message) return true
        }

        return false
    }

    getName = () => this.properties.getName()
    setName = (value:string) => this.properties.setName(value)
    setStatus = (value:any) => {
        // @ts-ignore
        this.properties.setStatus(value)
    }
    setUser = (value:any) => {
        // @ts-ignore
        this.properties.setUser(value)
    }

    toText() {
        if (this.isTaskMessage) {
            // @ts-ignore
            const {messageId} = this.properties
            const message = this.todoList.manager.app.messagesManager.getById(messageId)
            debug && console.log(debug, 'toText', message)
            return message.message
        } else {
            return this.properties.title
        }
    }

    toJSON() {
        switch (this.type) {
            case TODO_ITEM: return {
                uid             : this.uid,
                type            : this.type,
                properties      : this.properties.toJSON(),
                createdByUserId : this.createdByUserId,
                momentCreated   : this.momentCreated,
            }

            case TASK_ITEM: return {
                uid             : this.uid,
                type            : this.type,
                taskId          : this.taskId,
                createdByUserId : this.createdByUserId,
                momentCreated   : this.momentCreated
            }
        }
    }
}